import {
    Button,
    Flex,
    Spacer,
    Box,
    Avatar, Image, Menu, MenuButton, MenuList, MenuItem, DarkMode, Text, Tooltip, Link,
    useDisclosure,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    IconButton,
    useColorModeValue,
    useBreakpointValue,
    VStack, 
  } from "@chakra-ui/react"
  
  import { ColorModeSwitcher } from "../ColorModeSwitcher";
  import { useNavigate } from "react-router-dom";
  import React from 'react'; // Ensure React is explicitly imported
  
  import eduviclogo from "../resources/Eduvictechlogo.png";
  import { useState } from "react";
  import { jwtDecode } from "jwt-decode";
  import {  HamburgerIcon, CloseIcon, ChevronDownIcon, ExternalLinkIcon } from "@chakra-ui/icons";
  

  
  const NavBarTech = () => {
    const navigate = useNavigate();
    const [hover, setHover] = useState(false);

      const hoverBg = useColorModeValue('gray.100', 'gray.800');
      const hoverText = useColorModeValue('black', 'white');
 
     const { isOpen, onOpen, onClose } = useDisclosure();
      const isMobile = useBreakpointValue({ base: true, md: false });
  
    const menuItemStyles = {
      h: "30px", // Adjust to desired height
      py: 2, // Padding in the Y axis (top and bottom)
      fontWeight:"normal",
    };
  
    const menuHeadStyles = {
      h: "35px", // Adjust to desired height
      py: 2, // Padding in the Y axis (top and bottom)
    };
  
 
  const handleNavigation = (path: string) => {
    // For internal navigation within the same page
    if (path.startsWith('#')) {
      const element = document.getElementById(path.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    else if (path.startsWith('/platform')) {
          // Open in a new browser window
     window.open(path, '_blank', 'noopener,noreferrer');
    }
     else {
      navigate(path); 
    }
  };
  
      return (
       
        <>
<Flex
  as="nav"
  bg="blue.600"
  boxShadow="2xl"
  p={2}
  align="center"
  justify="space-between"
  position="fixed"
  top="0"
  width="full"
  zIndex="sticky"
  height="70px"
>

  {/* ============================================================
      LEFT SECTION
      Logo + Eduvic Technologies
      ============================================================ */}

    <Flex
      align="center"
      gap={{ base: 1, lg: 2, xl: 3 }}
      minW={0}
      flexShrink={1}
    >

      <Image
        src={eduviclogo}
        alt="Logo"
        boxSize={{ base: "68px", lg: "74px", xl: "80px" }}
        objectFit="contain"
        cursor={hover ? "pointer" : "default"}
        transition="0.3s"
        onClick={() =>
          handleNavigation("/technologies")
        }
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        flexShrink={0}
      />

      {!isMobile && (
        <Text
          fontWeight="bold"
          color="gray.300"
          fontSize={{ base: "sm", lg: "md" }}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          Technologies
        </Text>
      )}

    </Flex>


  {/* ============================================================
      CENTRE NAVIGATION
      Flexible and centred across available navbar space
      ============================================================ */}

  {!isMobile && (

    <Flex
      flex="1"
      minW={0}
      justify="center"
      align="center"
      gap={{ base: 0, lg: 1, xl: 2 }}
      overflow="hidden"
      mx={{ base: 1, lg: 2, xl: 3 }}
    >

      {/* ========================================================
          OUR VISION
          ======================================================== */}

      <Button
        variant="ghost"
        color="white"
        fontSize={{ base: "sm", lg: "md" }}
        size={{ base: "md", lg: "lg" }}
        px={{ base: 2, lg: 3, xl: 4 }}
        whiteSpace="nowrap"
        _hover={{
          bg: "blue.500",
        }}
        _focus={{
          boxShadow: "none",
        }}
        onClick={() =>
          handleNavigation(
            "/technologies/landing-page#ourvision"
          )
        }
      >
        Our Vision
      </Button>


      {/* ========================================================
          OUR PRODUCTS
          ======================================================== */}

      <Button
        variant="ghost"
        color="white"
        fontSize={{ base: "sm", lg: "md" }}
        size={{ base: "md", lg: "lg" }}
        px={{ base: 2, lg: 3, xl: 4 }}
        whiteSpace="nowrap"
        _hover={{
          bg: "blue.500",
        }}
        _focus={{
          boxShadow: "none",
        }}
        onClick={() =>
          handleNavigation(
            "/technologies/landing-page#ourproducts"
          )
        }
      >
        Our Products
      </Button>


      {/* ========================================================
          CASE STUDIES
          ======================================================== */}

      <Button
        variant="ghost"
        color="white"
        fontSize={{ base: "sm", lg: "md" }}
        size={{ base: "md", lg: "lg" }}
        px={{ base: 2, lg: 3, xl: 4 }}
        whiteSpace="nowrap"
        _hover={{
          bg: "blue.500",
        }}
        _focus={{
          boxShadow: "none",
        }}
        onClick={() =>
          handleNavigation(
            "/technologies/landing-page#casestudy"
          )
        }
      >
        Case Studies
      </Button>


      {/* ========================================================
          CONTACT US
          ======================================================== */}

      <Button
        variant="ghost"
        color="white"
        fontSize={{ base: "sm", lg: "md" }}
        size={{ base: "md", lg: "lg" }}
        px={{ base: 2, lg: 3, xl: 4 }}
        whiteSpace="nowrap"
        _hover={{
          bg: "blue.500",
        }}
        _focus={{
          boxShadow: "none",
        }}
        onClick={() =>
          handleNavigation(
            "/technologies/landing-page#contact"
          )
        }
      >
        Contact Us
      </Button>


      {/* ========================================================
          ABOUT US
          ======================================================== */}

      <Button
        variant="ghost"
        color="white"
        fontSize={{ base: "sm", lg: "md" }}
        size={{ base: "md", lg: "lg" }}
        px={{ base: 2, lg: 3, xl: 4 }}
        whiteSpace="nowrap"
        _hover={{
          bg: "blue.500",
        }}
        _focus={{
          boxShadow: "none",
        }}
        onClick={() =>
          handleNavigation(
            "/technologies/about-tech#about"
          )
        }
      >
        About Us
      </Button>

    </Flex>

  )}


  {/* ============================================================
      RIGHT SECTION
      ============================================================ */}

  <Flex
    align="center"
    gap={{ base: 1, lg: 2, xl: 3 }}
    flexShrink={0}
  >

    {/* ==========================================================
        MOBILE MENU
        ========================================================== */}

    {isMobile && (

      <IconButton
        aria-label="Open menu"
        icon={
          isOpen
            ? <CloseIcon />
            : <HamburgerIcon />
        }
        variant="ghost"
        color="white"
        _hover={{
          bg: "blue.500",
        }}
        onClick={onOpen}
      />

    )}


    {/* ==========================================================
        COLOUR MODE
        ========================================================== */}

{/*     <ColorModeSwitcher
      justifySelf="flex-end"
      _hover={{
        bg: "blue.500",
      }}
    /> */}

  </Flex>

</Flex>

        {/* Drawer for Mobile Menu */}
        <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader>
              <Flex justify="space-between" align="center">
                <Text fontSize="lg" fontWeight="bold">Menu</Text>
                <IconButton
                  aria-label="Close Menu"
                  icon={<CloseIcon />}
                  onClick={onClose}
                  variant="ghost"
                />
              </Flex>
            </DrawerHeader>
            <DrawerBody>
              <VStack align="stretch" spacing={0}>
                {[
                  { label: 'Our Vision', path: '/technologies/landing-page#ourvision' },
                  { label: 'Our Products', path: '/technologies/landing-page#ourproducts' },
                  //{ label: 'Case Studies', path: '/technologies/case-studies' },
                  { label: 'Case Studies', path: '/technologies/landing-page#casestudy' },
                  { label: 'About Us', path: '/technologies/about-tech#about' },
                  { label: 'Contact Us', path: '/technologies/landing-page#contact' },
                ].map((item, index) => {
        
        
                  return (
                    <React.Fragment key={item.label}>
                      <Box
                          onClick={() => {
                            handleNavigation(item.path);
                            onClose();
                          }}
                        cursor="pointer"
                        _hover={{ bg: hoverBg, color: hoverText }}
                        p={3}
                        fontSize="lg"
                        fontWeight="medium"
                      >
                        {item.label}
                      </Box>
                      {index < 6 && <Box borderBottom="1px" borderColor="gray.200" />}
                    </React.Fragment>
                  );
                })}
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        </>
      );
    };
  
    export default NavBarTech;